import createMathOperation from './_createMathOperation.js';

/**
 * Adds two numbers.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {number} augend The first number in an addition.
 * @param {number} addend The second number in an addition.
 * @returns {number} Returns the total.
 * @example
 *
 * _.add(6, 4);
 * // => 10
 */
var add = createMathOperation(function(augend, addend) {
  return augend + addend;
}, 0);

export default add;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/add.js
// module id = 563
// module chunks = 41